import styled from 'styled-components';

import {
  Flex,
} from 'web-styled';

export const Label = styled.label`
  color: rgb(107, 119, 140);
  font-size: 12px;
  font-weight: 600;
  line-height: 1.33333;
  padding: 20px 0px 4px;
`;

export const Footer = styled(Flex).attrs({
  column: true,
})`
  width: 100%;
  margin-top: auto;
  padding-top: 30px;

  hr {
    height: 1px;
    border: 0;
    border-top: 1px solid #ccc;
    margin: 1em 0;
    padding: 0;
  }
`;
